import Hero from './components/Hero';
import FeaturedInventory from './components/FeaturedInventory';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <FeaturedInventory />
      <Contact />
      <Footer />
    </div>
  );
}
